<img src="assets/tvd-added-icon.png" class="icon-added" alt="Added Icon">